export const BUTTON = 'button'
export const SUBMIT = 'submit'
export const RESET = 'reset'
export type ButtonTypes = 'button' | 'submit' | 'reset' | undefined

export const PRIMARY = 'primary'
export const SECONDARY = 'secondary'
export const TRANSPARENT = 'transparent'
export type ButtonStyle = 'primary' | 'secondary' | 'third' | 'transparent' | undefined
